import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListNotificationPayload } from '@app-store/slices/notifications/list'

interface TaskAction extends Action {
    payload: IListNotificationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.notification.list

function* listNotificaionSagaTask({ payload }) {
    const params = yield getParams(payload)
    try {
        const response = yield axios.get(`/notifications`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listNotificaionSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listNotificaionSagaTask)
}

export default listNotificaionSaga
